import { defineStore, acceptHMRUpdate } from "pinia";
import { setStore, getStore, removeStore, clearStore } from "@/util/store.js";
import crypto from "@/util/crypto.js";
import func from "@/util/func.js";
import moment from "moment";
import { showDialog, showToast } from "vant";
import {
  getLoginInfo,
  toLogin,
  refreshToken,
  getQWsignature,
  getJuziUserInfo,
  getMiniProgramAppId,
} from "@/api/base.js";
import { createGroupNotice } from "@/api/group.js";
import { loadingStore } from "@/store/loading.js";
import { isJuzi, getWx, ensureCurrentUserInUserIds } from "@/util/platform.js";
//import { userStore } from '@/store/user.js';
// wm219eaAAAPNyWdZQOaxkmfafxNmH7eQ

// 橘子侧边栏 OAuth 服务地址。该地址是橘子平台提供的授权服务，不是当前前端项目地址。
const JUZI_OAUTH_ORIGIN = "https://stride-bg.dpclouds.com";
const JUZI_OAUTH_AUTHORIZE_PATH = "/api/oauth/connect/authorize";
const JUZI_OAUTH_CODE_PARAM = "code";
const JUZI_OAUTH_STATE_PARAM = "state";
const JUZI_OAUTH_ERROR_PARAM = "error";
const JUZI_OAUTH_ERROR_DESCRIPTION_PARAM = "error_description";

/**
 * 获取 OAuth 回调地址。
 * 保留 juziSidebar、juziUrl 以及业务页面参数，避免授权回跳后丢失橘子侧边栏运行环境。
 */
function getJuziOAuthRedirectUri() {
  const callbackUrl = new URL(window.location.href);

  // 回调地址不能携带上一次授权产生的参数，否则重新授权时会直接使用失效 code。
  callbackUrl.searchParams.delete(JUZI_OAUTH_CODE_PARAM);
  callbackUrl.searchParams.delete(JUZI_OAUTH_STATE_PARAM);
  callbackUrl.searchParams.delete(JUZI_OAUTH_ERROR_PARAM);
  callbackUrl.searchParams.delete(JUZI_OAUTH_ERROR_DESCRIPTION_PARAM);

  return callbackUrl.toString();
}

/**
 * 跳转到橘子 OAuth 授权页。
 * 授权服务会将 redirect_uri 交给侧边栏宿主处理，因此必须使用完整且编码后的当前回调地址。
 */
function redirectToJuziOAuth() {
  const authorizationUrl = new URL(
    JUZI_OAUTH_AUTHORIZE_PATH,
    JUZI_OAUTH_ORIGIN,
  );
  const redirectUri = getJuziOAuthRedirectUri();
  const state =
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  removeStore({ name: "token" });
  
  authorizationUrl.searchParams.set("redirect_uri", redirectUri);
  authorizationUrl.searchParams.set(JUZI_OAUTH_STATE_PARAM, state);
  window.location.replace(authorizationUrl.toString());
}

export const userStore = defineStore("user", {
  // 其他配置...
  state: () => ({
    tenantId: getStore({ name: "tenantId" }) || "", //租户ID
    token: getStore({ name: "token" }) || null,
    userInfo: getStore({ name: "userInfo" }) || "", //用户信息
    qwUserinfo: getStore({ name: "qwUserInfo" }) || "", //企微的用户信息
    agentId: getStore({ name: "agentId" }) || "", //应用ID
    corpId: getStore({ name: "corpId" }) || "", //企业ID
    // cusId: 'wm219eaAAAPNyWdZQOaxkmfafxNmH7eQ',//当前客户id
    isInlogin: false, //正在登录
    isLogErr: false, //登录失败
    CurrentClientId: "", //当前客户
    tokenClock: null, //刷新TOKEN的全局变量
    refreshingToken: false, //正在刷新token
    wxAppId: getStore({ name: "wxAppId" }) || "", //微信小程序绑定ID - 默认从localStorage中获取
    miniprogramOriginId: getStore({ name: "miniprogramOriginId" }) || "", //小程序原始ID - 默认从localStorage中获取
    chatId: "", //群聊ID
    isSingleChat: false, //是否为单聊
    isGroupChat: false, //是否为群聊
    cusId: "", //当前客户id
    cusInfo: {}, //当前客户信息
  }),
  getters: {
    editstate: (state) => {
      console.log(state);
    },
  },
  actions: {
    /**
     * 初始化橘子平台登录。
     * 首次进入跳转 OAuth；回调携带 code 后直接获取用户信息，避免再次调用 juziLogin。
     */
    initJuziLogin() {
      const urlParams = new URLSearchParams(window.location.search);
      const oauthCode = urlParams.get(JUZI_OAUTH_CODE_PARAM);

      if (!func.isEmpty(oauthCode) && oauthCode !== null) {
        this.reqJuziUserInfo(oauthCode);
        return;
      }

      redirectToJuziOAuth();
    },
    wxLogin() {
      if (!func.isEmpty(this.userInfo)) {
        console.log("已有用户信息，跳过登录");
        return;
      }

      // ★ 橘子平台：走橘子 OAuth 登录流程
    //   if (isJuzi()) {
    //     console.log("橘子平台登录");
    //     this.juziLogin();
    //     return;
    //   }

      // 企微平台：走原有企微 OAuth 登录流程
      console.log("微信用户登录");

      //获取网页当前链接，检查链接中是否有名称为code的参数，如果有 保存这个参数，带参数执行do方法

      function redirectToWeChatAuth(params) {
        if (func.isEmpty(params.appid)) {
          return;
        }
        const baseUrl = "https://open.weixin.qq.com/connect/oauth2/authorize";
        // 替换URL中的参数
        const newUrl = `${baseUrl}?appid=${params.appid}&redirect_uri=${params.redirect_uri}&agentid=${params.agentid}&response_type=code&scope=${params.scope}&state=${params.state}#wechat_redirect`;
        // 使用 window.location.href 跳转到新URL
        window.location.replace(newUrl);
      }

      const currentURL = window.location.href;

      const urlParams = new URLSearchParams(currentURL.split("?")[1]);

      let code = urlParams.get("code");
      let state = urlParams.get("state");

      // 检查链接中是否包含名为"code"的参数

      if (!func.isEmpty(code) && code != null) {
        // 获取参数值
        this.reqUserInfo(code, state);
      } else {
        // 如果没有"code"参数，执行redirectToWeChatAuth方法并传递authParams

        //const currentURL = window.location.href;
        const urlParams = new URLSearchParams(currentURL.split("?")[1]);
        const paramsObject = {};
        for (const [key, value] of urlParams) {
          paramsObject[key] = value;
        }

        const authParams = {
          appid: paramsObject.appid,
          redirect_uri: paramsObject.redirect_uri,
          scope: paramsObject.scope,
          state: paramsObject.state,
          agentid: paramsObject.agentid,
        };

        redirectToWeChatAuth(authParams);
      }
    },
    /**
     * 橘子平台 - 登录入口
     * 检查URL中是否有橘子OAuth回调的code参数，有则换取token，无则重定向到橘子授权页
     */
    juziLogin() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get(JUZI_OAUTH_CODE_PARAM);

      if (!func.isEmpty(code) && code !== null) {
        // 有 code → 调后端 SSO 接口换取 token
        this.reqJuziUserInfo(code);
      } else {
        // 无 code → 重定向到橘子 OAuth 授权页
        redirectToJuziOAuth();
      }
    },
    /**
     * 橘子平台 - 用 OAuth code 获取托管账号信息，并复用系统登录流程换取 token
     */
    reqJuziUserInfo(code) {
      console.log("橘子平台 - 请求SSO登录");
      let that = this;

      getJuziUserInfo(code)
        .then((res) => {
          // 新接口结构与 reqUserInfo 一致，托管账号信息位于 res.data.data。
          const { data } = res.data;
          if (!data) {
            throw new Error("橘子平台未返回托管账号信息");
          }
          console.log("橘子平台 - 获取托管账号信息成功");
          // 橘子平台设置用户信息
          that.juziSetQwuserInfo(data);
        })
        .catch((err) => {
          console.error("橘子平台 - SSO登录失败", err);
          showDialog({
            title: "登录失败",
            message:
              err.error_description ||
              err.message ||
              "橘子平台登录失败，请重试",
            confirmButtonColor: "#28B8C3",
          }).then(() => {
            localStorage.clear();
            that.userInfo = "";
            that.token = "";
          });
        });
    },
    reqUserInfo(code, state) {
      //请求用户信息
      console.log("请求用户信息");
      let that = this;

      getLoginInfo({
        code,
        state,
      }).then((res) => {
        //获取到了用户信息
        let { data } = res.data;
        that.setQWuserInfo(data);
      });
    },
    setQWuserInfo(data) {
      //设置企微的用于信息
      this.qwUserinfo = data;

      setStore({
        name: "qwUserInfo",
        content: data,
      });

      console.log("企微用户信息");
      console.log(this.qwUserinfo);

      this.toLoginSubmit(data.tenantId, data.id);
      this.setTenantId(data.tenantId);
    },
    juziSetQwuserInfo(data) {
      let that = this;
      this.qwUserinfo = data;

      setStore({
        name: "qwUserInfo",
        content: data,
      });

      console.log("企微用户信息");
      console.log(this.qwUserinfo);

      //设置租户id
      this.setTenantId(data.tenantId);
      //设置企业id
      that.corpId = data.corpId;
      setStore({
        name: "corpId",
        content: data.corpId,
      });

      //设置应用id
      that.agentId = data.agentId;
      setStore({
        name: "agentId",
        content: data.agentId,
      });

      // 橘子平台使用 uid 作为登录凭证，采用独立的 RPA 授权类型。
      this.juziToLoginSubmit(data.tenantId, data.uid);
    },
    /**
     * 橘子平台登录：使用托管账号 uid 换取系统 Token。
     * @param {string} tenantId 租户 ID
     * @param {string} uid 橘子平台返回的用户 ID
     */
    juziToLoginSubmit(tenantId, uid) {
      if (this.isInlogin || this.isLogErr) {
        return;
      }

      const that = this;
      // uid 与原企微登录的员工 ID 一致，均需要加密后再传给登录接口。
      const encryptedUid = crypto.encrypt(uid);
      const loginParams = {
        tenant_id: tenantId,
        grant_type: "wecom_rpa",
        scope: "all",
        secretText: encryptedUid,
      };

      this.isInlogin = true;
      toLogin(loginParams)
        .then((res) => {
          const loginData = res.data;
          const { access_token, refresh_token } = loginData;

          if (!func.isEmpty(access_token)) {
            that.setUserInfo(loginData);
            that.setToken(access_token);
            that.setRefreshToken(refresh_token);

            // 橘子平台登录成功后，获取关联的小程序 AppId。
            getMiniProgramAppId()
              .then((appIdRes) => {
                const { appId, appOriginalId } = appIdRes?.data?.data || {};

                if (!func.isEmpty(appId)) {
                  that.wxAppId = appId;
                  setStore({
                    name: "wxAppId",
                    content: appId,
                  });

                  that.miniprogramOriginId = appOriginalId;
                  setStore({
                    name: "miniprogramOriginId",
                    content: appOriginalId,
                  });
                }
              })
              .catch((err) => {
                console.error("橘子平台获取小程序AppId失败", err);
                // 获取小程序 AppId 失败时提示用户，确认后清缓存并重新进入授权流程
                showDialog({
                  title: "获取失败",
                  message: "平台获取小程序AppId失败，请点击确定后重新登录",
                  confirmButtonColor: "#28B8C3",
                }).then(() => {
                  that.clearStorageAndReload();
                });
              });
          }

          that.isInlogin = false;
        })
        .catch((err) => {
          console.log("橘子平台登录失败", err);

          if (err.error == "invalid_grant") {
            showDialog({
              title: "登录失败",
              message: err.error_description,
              confirmButtonColor: "#28B8C3",
            });
          }

          that.isInlogin = false;
        });
    },
    toLoginSubmit(tenant_id, secretText) {
      //登录

      let that = this;
      if (this.isInlogin || this.isLogErr) {
        return;
      }

      secretText = crypto.encrypt(secretText);

      let subdata = {
        tenant_id,
        grant_type: "wecom",
        scope: "all",
        secretText,
      };
      this.isInlogin = true;
      toLogin(subdata)
        .then((res) => {
          const data = res.data;
          const { access_token, refresh_token } = data;

          if (!func.isEmpty(access_token)) {
            that.setUserInfo(data);
            that.setToken(access_token);
            that.setRefreshToken(refresh_token);
          }

          this.isInlogin = false;
        })
        .catch((err) => {
          if (err.error == "invalid_grant") {
            showDialog({
              title: "登录失败",
              message: err.error_description,
              confirmButtonColor: "#28B8C3",
            }).then(() => {});
          }
          this.isInlogin = false;
        });
    },
    setUserInfo(data) {
      this.userInfo = data;
      setStore({
        name: "userInfo",
        content: data,
      });
    },
    setToken(token) {
      this.token = token;
      setStore({
        name: "token",
        content: token,
      });
    },
    setRefreshToken(token) {
      const now = moment();

      //10分钟后
      const oneHourLater = moment(now).add(10, "minutes").format("x");

      // const oneHourLater = moment(now).add(1, "hour").format("x");

      let refreshTokeninfoData = {
        refresh_token: token,
        expiration_time: oneHourLater,
      };

      setStore({
        name: "refreshTokeninfo",
        content: refreshTokeninfoData,
      });
    },
    setTenantId(tenantId) {
      //设置全局租户ID
      setStore({
        name: "tenantId",
        content: tenantId,
      });
    },
    toRefreshToken(refresh_token) {
      let that = this;

      // ★ 橘子平台：如果没有 refresh_token，重新走 OAuth 授权
      if (isJuzi() && func.isEmpty(refresh_token)) {
        this.clearStorageAndReload();
        return Promise.reject("橘子平台无 refresh_token，重新授权");
      }

      //刷新TOKEN
      return new Promise((resolve, reject) => {
        refreshToken(refresh_token, that.userInfo.tenant_id, {
          clinic_id: that.userInfo.detail.clinic_id,
        })
          .then((res) => {
            const data = res.data;
            const { access_token, refresh_token } = data;
            this.setUserInfo(data);
            this.setToken(access_token);
            this.setRefreshToken(refresh_token);
            resolve();
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    replacementClinic(clinicId) {
      //切换诊所
      let that = this;
      let { expiration_time, refresh_token } = getStore({
        name: "refreshTokeninfo",
      });

      if (func.isEmpty(refresh_token)) {
        refresh_token = getStore({ name: "refreshTokeninfo" });
        if (func.isEmpty(refresh_token)) {
          reject("refresh_token is empty");
          return;
        }
      }

      return new Promise((resolve, reject) => {
        refreshToken(refresh_token, that.userInfo.tenant_id, {
          clinic_id: clinicId,
        })
          .then((res) => {
            const data = res.data;

            that.setUserInfo(data);
            that.setToken(data.access_token);
            that.setRefreshToken(data.refresh_token);
            //设置诊所信息到userInfo的detail中
            resolve(data.detail);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    testHasToken(num = 0) {
      // 同步函数进入时检测如果this.token不为null则 resolve 否则1秒后再次检测
      let that = this;
      let loading = loadingStore();

      return new Promise((resolve, reject) => {
        (function checkToken(num) {
          if (num > 20) {
            // nobind 绑定页：不弹超时提示、不清缓存重置（与 axios 401 处理保持一致）
            const pathName = window.location.pathname || "";
            if (pathName.includes("/nobind")) {
              reject();
              return;
            }
            // that.clearStorageAndReload();
            showDialog({
              title: "登录超时",
              message: "登录超时，请点击确定后重新登录（401）",
              confirmButtonColor: "#28B8C3",
            }).then(() => {
              that.clearStorageAndReload();
            });

            reject();
            return;
          } else if (!func.isEmpty(that.token)) {
            //判断是否过期

            // let refreshTokeninfo =  getStore({'name':'refreshTokeninfo'})
            let { expiration_time, refresh_token } = getStore({
              name: "refreshTokeninfo",
            });
            let currentTime = moment().format("x");
            if (
              Number(currentTime) > Number(expiration_time) &&
              !that.refreshingToken
            ) {
              //刷新TOKEN

              that.refreshingToken = true;
              that
                .toRefreshToken(refresh_token)
                .then(() => {
                  that.refreshingToken = false;
                  checkToken(++num);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else if (that.refreshingToken) {
              //正在请求刷新Token的接口
              setTimeout(() => {
                checkToken(++num);
              }, 1500);
            } else {
              loading.hideLoading();
              resolve(that.token);
            }
          } else {
            //登录
            console.log("下");
            loading.showLoading("正在登录", 1000 * 20);
            //that.toLoginbefore();
            setTimeout(() => {
              checkToken(++num);
            }, 1500);
          }
        })(0);
      });
    },
    refreshTokenTime() {
      //开启刷新Token
      const that = this;
      const refreshInterval = 1 * 10 * 1000; // 刷新间隔时间为1小时

      this.tokenClock = setInterval(() => {
        const { expiration_time, refresh_token } = getStore({
          name: "refreshTokeninfo",
        });
        const currentTime = moment().valueOf(); // 使用 moment.js 获取当前时间的时间戳

        if (Number(currentTime) > Number(expiration_time)) {
          // 刷新 TOKEN 的逻辑
          that.toRefreshToken(refresh_token);
        }
      }, refreshInterval);
    },
    getAgentConfig() {
      //用于获取当前选中的客户
      let that = this;
      let { agentId, corpId } = that;
      const wx = getWx();

      // 橘子平台：无需 agentConfig 鉴权，直接获取外部联系人
      if (isJuzi()) {
        return new Promise((resolve, reject) => {
          wx.invoke("getCurExternalContact", {}, function (res) {
            if (res.err_msg == "getCurExternalContact:ok") {
              let userId = res.userId;
              that.cusId = userId;
              resolve(userId);
            } else {
              console.log("橘子平台获取外部联系人失败", res);
              // 获取外部联系人失败时提示用户，确认后清缓存并重新进入授权流程
              showDialog({
                title: "获取失败",
                message: "平台获取外部联系人失败，请点击确定后重新登录",
                confirmButtonColor: "#28B8C3",
              }).then(() => {
                that.clearStorageAndReload();
              });
              reject(res);
            }
          });
        });
      }

      return new Promise((resolve, reject) => {
        //请求后端获取配置

        const currentURL = window.location.href;

        getQWsignature({
          agentId: agentId,
          corpId: corpId,
          url: currentURL,
          type: "2",
        }).then((res) => {
          let configinfo = res.data.data;

          wx.agentConfig({
            corpid: configinfo.corpId, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            agentid: configinfo.agentId, // 必填，企业微信的corpID
            timestamp: configinfo.timestamp, // 必填，生成签名的时间戳
            nonceStr: configinfo.nonceStr, // 必填，生成签名的随机串
            signature: configinfo.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: [
              "getContext",
              "getCurExternalContact",
              "sendChatMessage",
              "updateEnterpriseChat",
              "setClipboardData",
            ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            success: function (res) {
              wx.invoke("getContext", {}, function (res) {
                if (
                  res.err_msg == "getContext:ok" ||
                  res.errMsg == "agentConfig:ok"
                ) {
                  wx.invoke("getCurExternalContact", {}, function (res) {
                    if (res.err_msg == "getCurExternalContact:ok") {
                      let userId = res.userId; //返回当前外部联系人userId
                      that.cusId = userId;
                      resolve(userId);
                    } else {
                      console.log("409行错误信息", res);
                      alert(res);
                      that.wxClose(wx);
                      reject(res);
                    }
                  });
                } else {
                  //错误处理
                  reject("wx.invoke error");
                }
              });
            },
            fail: function (res) {
              if (res.errMsg.indexOf("function not exist") > -1) {
                this.jsApiList.performAlert("版本过低请升级");
              }
              reject("wx.agentConfig error");
            },
          });

          wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          });
          wx.error(function (res) {
            console.log("微信启动错误");
            reject(res);
          });
        });
      });
    },
    ValidateEntryEnvironment() {
      //验证是在单聊还是群聊
      let that = this;
      let { agentId, corpId } = that;
      const wx = getWx();

      // 橘子平台：使用 getCurChatInfo 判断会话类型
      if (isJuzi()) {
        return new Promise((resolve, reject) => {
          wx.getCurChatInfo({
            success: function (res) {
              // type: 0 单聊, 1 群聊
              that.isSingleChat = res.type === 0;
              that.isGroupChat = res.type === 1;
              resolve({
                entry:
                  res.type === 0 ? "single_chat_tools" : "group_chat_tools",
              });
            },
            fail: function (res) {
              console.error("橘子平台获取会话信息失败", res);
              // 获取会话信息失败时提示用户，确认后清缓存并重新进入授权流程
              showDialog({
                title: "获取失败",
                message: "平台获取会话信息失败，请点击确定后重新登录",
                confirmButtonColor: "#28B8C3",
              }).then(() => {
                that.clearStorageAndReload();
              });
              reject(res);
            },
          });
        });
      }

      const currentURL = window.location.href;
      return new Promise((resolve, reject) => {
        getQWsignature({
          agentId: agentId,
          corpId: corpId,
          url: currentURL,
          type: "2",
        }).then((res) => {
          let configinfo = res.data.data;
          wx.agentConfig({
            corpid: configinfo.corpId, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            agentid: configinfo.agentId, // 必填，企业微信的corpID
            timestamp: configinfo.timestamp, // 必填，生成签名的时间戳
            nonceStr: configinfo.nonceStr, // 必填，生成签名的随机串
            signature: configinfo.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: ["getContext"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            success: function (res) {
              wx.invoke("getContext", {}, function (res) {
                //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
                if (res.err_msg == "getContext:ok") {
                  //判断是否单聊
                  that.isSingleChat = res.entry === "single_chat_tools";
                  //判断是否群聊
                  that.isGroupChat = res.entry === "group_chat_tools";
                  //返回数据
                  resolve({
                    entry: res.entry,
                  });
                  //shareTicket = res.shareTicket; //可用于调用getShareInfo接口
                } else {
                  //错误处理
                  console.log(res);
                }
              });
            },
            fail: function (res) {
              console.error(res);
            },
          });
        });
      });
    },
    setAgentIdCorpId() {
      //从链接中获取 state
      let that = this;

      function removePrefix(inputString, prefix) {
        const regex = new RegExp("^" + prefix);
        const removedPart = inputString.replace(regex, "");
        return removedPart;
      }

      const currentURL = window.location.href;
      const urlParams = new URLSearchParams(currentURL.split("?")[1]);
      let state = urlParams.get("state");

      //state 为  1000006ww82e51ece6311fcc5 我需要将数字和后面的字符拆分成  AgentId 和 CorpId 变量

      // 使用正则表达式匹配数字和字符部分
      let match = null;

      if (state) {
        match = state.match(/(\d+)([a-zA-Z]+)/);
      }

      if (match) {
        // 第一个捕获组对应 AgentId，第二个捕获组对应 CorpId
        const AgentId = match[1];
        const corpId = removePrefix(state, AgentId);

        that.agentId = AgentId;
        that.corpId = corpId;

        setStore({
          name: "agentId",
          content: AgentId,
        });

        setStore({
          name: "corpId",
          content: corpId,
        });
      }
    },
    setwxAppid() {
      let that = this;
      const currentURL = window.location.href;
      const urlParams = new URLSearchParams(currentURL.split("?")[1]);
      let wxAppId = urlParams.get("wxappid");
      if (!func.isEmpty(wxAppId)) {
        that.wxAppId = wxAppId;
        setStore({
          name: "wxAppId",
          content: wxAppId,
        });
      }
    },
    wxClose(wx) {
      let that = this;
      window.close();
      wx.invoke("close", () => {});
    },
    getWxconfig(jsApiList) {
      //获取微信当前页面的配置 需要调用什么方法从外部传入
      const wx = getWx();

      // 橘子平台：无需签名鉴权，直接可用
      if (isJuzi()) {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const currentURL = window.location.href;
        getQWsignature({
          agentId: this.agentId,
          corpId: this.corpId,
          url: currentURL,
          type: "2",
        })
          .then((res) => {
            wx.agentConfig({
              corpid: res.data.data.corpId,
              agentid: res.data.data.agentId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              signature: res.data.data.signature,
              jsApiList: jsApiList, // Pass jsApiList as an argument
              success: function (res) {
                if (
                  res.err_msg == "getContext:ok" ||
                  res.errMsg == "agentConfig:ok"
                ) {
                  resolve();
                } else {
                  reject("getContext error");
                }
                //   if (res.err_msg === "getContext:ok") {
                //     resolve()
                //   } else {
                // console.log(res);
                // reject('getContext error');
                //   }
              },
              fail: function (res) {
                if (res.errMsg.indexOf("function not exist") > -1) {
                  this.jsApiList.performAlert("版本过低请升级");
                }
                reject("wx.agentConfig error:" + res.errMsg);
              },
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setCusId(cusId) {
      //从其它地方进来的时候需要将客户ID设置上
      let that = this;
      that.cusId = cusId;
    },
    setCusInfo(cusInfo) {
      //设置当前客户信息
      this.cusInfo = cusInfo;
    },
    clearStorageAndReload() {
      //清空缓存并且重新进入
      let that = this;
      localStorage.clear();
      that.userInfo = "";
      that.token = "";

      //橘子平台：重定向到橘子 OAuth 授权页
      if (isJuzi()) {
        redirectToJuziOAuth();
        return;
      }

      let pathname = window.location.pathname;
      let page = `${window.location.origin}/entrypage?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/entrypage&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;

      // if (pathname == '/pushPage') {
      //     let wxappid = that.wxAppId || getStore({ name: 'wxAppId' }) || '';
      //     if (wxappid) {
      //         page = `${window.location.origin}/pushPage?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/pushPage&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}&wxappid=${wxappid}`;
      //     } else {
      //         page = `${window.location.origin}/pushPage?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/pushPage&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;
      //     }
      // }

      // if (pathname == '/waitingProcessing') {
      //     let wxappid = that.wxAppId || getStore({ name: 'wxAppId' }) || '';
      //     if (wxappid) {
      //         page = `${window.location.origin}/waitingProcessing?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/waitingProcessing&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}&wxappid=${wxappid}`;
      //     } else {
      //         page = `${window.location.origin}/waitingProcessing?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/waitingProcessing&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;
      //     }
      // }

      // if (pathname == '/wecomAppHomePage') {
      //     let wxappid = that.wxAppId || getStore({ name: 'wxAppId' }) || '';
      //     if (wxappid) {
      //         page = `${window.location.origin}/wecomAppHomePage?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/wecomAppHomePage&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}&wxappid=${wxappid}`;
      //     } else {
      //         page = `${window.location.origin}/wecomAppHomePage?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/wecomAppHomePage&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;
      //     }
      // }

      // if (pathname == '/materialLibrary/materialList') {
      //     let wxappid = that.wxAppId || getStore({ name: 'wxAppId' }) || '';
      //     if (wxappid) {
      //         page = `${window.location.origin}/materialLibrary/materialList?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/materialLibrary/materialList&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}&wxappid=${wxappid}`;
      //     } else {
      //         page = `${window.location.origin}/materialLibrary/materialList?jump=wx&appid=${this.corpId}&redirect_uri=${window.location.origin}/materialLibrary/materialList&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;
      //     }
      // }

      const generatePageUrl = (pathname, that) => {
        const wxappid = that.wxAppId || getStore({ name: "wxAppId" }) || "";
        const baseUrl = `${window.location.origin}${pathname}?jump=wx&appid=${that.corpId}&redirect_uri=${window.location.origin}${pathname}&scope=snsapi_privateinfo&agentid=${that.agentId}&state=${that.agentId}${that.corpId}`;
        return wxappid ? `${baseUrl}&wxappid=${wxappid}` : baseUrl;
      };

      const pathnames = [
        "/pushPage",
        "/waitingProcessing",
        "/wecomAppHomePage",
        "/materialLibrary/materialList",
        "/nobind",
      ];

      // 判断 pathname 是否包含 materialLibrary/materialList 或者 materialLibrary/subdirectory
      if (
        pathname.includes("materialLibrary/materialList") ||
        pathname.includes("materialLibrary/subdirectory")
      ) {
        // 如果包含，则将 pathname 改为 /materialLibrary/materialList
        pathname = "/materialLibrary/materialList";
      }

      //前面是判断侧边栏页面，pc端都默认跳回原路径
      if (pathnames.includes(pathname)) {
        const page = generatePageUrl(pathname, that);
        window.location.replace(page);
      } else if (pathname.includes("/pc")) {
        //如果是电脑端重新登录返回到首页，主要是为了处理绑定跳转的问题
        const page = generatePageUrl("/pc/clinicWorkspace", that);
        window.location.replace(page);
      } else {
        window.location.replace(page);
      }
    },
    loginTimeout(
      title = "登录超时",
      message = "登录超时，请点击确定后重新登录（401）",
    ) {
      let that = this;
      showDialog({
        title: title,
        message: message,
        confirmButtonColor: "#28B8C3",
      }).then(() => {
        that.clearStorageAndReload();
      });
    },
    shareImageToChat(mediaid) {
      const wx = getWx();
      try {
        wx.invoke("sendChatMessage", {
          msgtype: "image",
          image: {
            mediaid: mediaid,
          },
          success: function () {
            showDialog({
              title: "分享成功",
              message: "图片分享成功",
              confirmButtonColor: "#28B8C3",
            });
          },
          fail: function (err) {
            console.log(err);
            showDialog({
              title: "分享失败",
              message: err.errMsg,
              confirmButtonColor: "#28B8C3",
            });
          },
        });
      } catch (error) {
        console.log(error);
        // 处理错误的代码
        showToast("分享失败，请在企业微信中操作");
      }
    },
    //获取当前群聊id
    getCurrentChatId() {
      const that = this;
      const wx = getWx();
      new Promise((resolve, reject) => {
        that.getWxconfig(["getCurExternalChat"]).then(() => {
          wx.invoke("getCurExternalChat", {}, function (res) {
            if (res.err_msg == "getCurExternalChat:ok") {
              that.chatId = res.chatId; //返回当前外部群的群聊ID
              resolve(res.chatId);
            } else {
              //错误处理
            }
          });
        });
      });
    },
    /**
     * 拉群（打开/创建客户群）
     * 幂等性说明：非幂等。chatId 为空时会尝试创建新会话，重复调用可能产生不同会话。
     */
    joinGroup(joinGroupParams = {}, templateId = "") {
      // 先按需求写死默认参数，业务侧可通过入参覆盖
      // const DEFAULT_JOIN_GROUP_PARAMS = {
      //     userIds: "BeiCheng;BangBangDa",
      //     externalUserIds: "wmTzNNWgAAhYJOPlWbOROGx6ByURxh-A",
      //     groupName: "讨论组1",
      //     chatId: "",
      // };
      const finalJoinGroupParams = {
        ...joinGroupParams,
      };

      // 橘子平台：拉群需传入企业微信企业成员 userId（必传）
      // 若业务侧已传入 userIds，则校验当前用户是否已包含，未包含才追加，避免覆盖传入成员
      if (isJuzi()) {
        ensureCurrentUserInUserIds(
          finalJoinGroupParams,
          this.qwUserinfo?.userId || "",
        );
      }

      console.log("打开外部聊天信息");
      console.log(finalJoinGroupParams);

      return new Promise((resolve, reject) => {
        this.getWxconfig(["openEnterpriseChat"])
          .then(() => {
            const wx = getWx();
            // 兼容新版（wx.qy.openEnterpriseChat）和部分旧版本写法（wx.openEnterpriseChat）
            const openEnterpriseChatFunction =
              wx?.qy?.openEnterpriseChat || wx?.openEnterpriseChat;

            if (!openEnterpriseChatFunction) {
              reject("openEnterpriseChat is not available");
              return;
            }

            openEnterpriseChatFunction({
              ...finalJoinGroupParams,
              success: async (openRes) => {
                const chatIdValue = openRes?.chatId || "";
                const hasTemplateId =
                  templateId !== "" &&
                  templateId !== null &&
                  templateId !== undefined;
                // 仅在传入 templateId 且成功拿到 chatId 时，通知后端保存建群记录，避免影响其它 joinGroup 场景
                if (hasTemplateId && chatIdValue) {
                  await createGroupNotice({
                    chatId: chatIdValue,
                    corpId: this.corpId || "",
                    templateId: templateId,
                  });
                }
                resolve(openRes);
              },
              fail: function (openErr) {
                reject(openErr);
              },
            });
          })
          .catch((configErr) => {
            reject(configErr);
          });
      });
    },

    /**
     * 直接封装 updateEnterpriseChat：只做加人动作
     * 入参示例：
     * { chatId: 'xxx', userIdsToAdd: 'userA;userB' }
     */
    updateGroupMember(addGroupMemberParams = {}, successCallback = null) {
      //拉群带注册权限
      const DEFAULT_ADD_MEMBER_PARAMS = {
        chatId: "",
        userIdsToAdd: "",
      };

      const finalUpdateGroupMemberParams = {
        ...DEFAULT_ADD_MEMBER_PARAMS,
        ...addGroupMemberParams,
      };

      return new Promise((resolve, reject) => {
        this.getWxconfig(["updateEnterpriseChat"]).then(() => {
          const wx = getWx();
          const chatId = finalUpdateGroupMemberParams.chatId;
          const userIdsToAdd = finalUpdateGroupMemberParams.userIdsToAdd;
          try {
            /**
             * 这里微信会调用 wx.invoke 方法，但是如果不在群里不会给与任何反馈无法捕获到不在群里的错误
             * 官方也没有提供调起对话框的接口。所以如果连续加群碰到没有展示的内容会被阻塞在这里
             */
            wx.invoke(
              "updateEnterpriseChat",
              {
                chatId,
                userIdsToAdd,
              },
              function (invokeRes) {
                console.log(invokeRes);
                if (invokeRes.err_msg === "updateEnterpriseChat:ok") {
                  // 加群成功后执行外部回调，用于串行触发下一次加群。
                  if (typeof successCallback === "function") {
                    successCallback(invokeRes);
                  }
                  resolve(invokeRes);
                } else {
                  reject(invokeRes);
                }
              },
            );
          } catch (error) {
            reject(error);
            console.log(error);
          }
        });
      });
    },
  },
});
